import React from 'react';

import { mosaiqStyled } from '../../lib';

import { ProgressBarProps } from './types';

import { calculatePercentage } from './utils';

import { ProgressBarContainer, ProgressBarProgression } from './ProgressBar.styles';

const ProgressBar = mosaiqStyled<ProgressBarProps, HTMLDivElement>(
  ({ value, total, initial = 0, innerRef, ...props }) => {
    return (
      <ProgressBarContainer
        role="progressbar"
        aria-valuenow={value}
        aria-valuemax={total}
        aria-valuemin={initial}
        ref={innerRef}
        {...props}
      >
        <ProgressBarProgression
          progress={calculatePercentage({
            initial,
            total,
            value,
          })}
        />
      </ProgressBarContainer>
    );
  },
);

export default ProgressBar;
